<script setup lang="ts">
import { watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Toaster } from 'vue-sonner'
// Without this the toasts render as bare text in the page's top-left corner —
// which is exactly where a nervous first-timer's eye goes when saving.
import 'vue-sonner/style.css'
import { useAuth } from '@/composables/useAuth'
import { useTheme } from '@/composables/useTheme'
import AppShell from '@/layout/AppShell.vue'

const router = useRouter()
const { isAuthenticated } = useAuth()
const { initializeTheme } = useTheme()

onMounted(() => initializeTheme())

// A session ending anywhere (an expired token, a 401 interceptor) should land
// the user on the login screen rather than an empty frame.
watch(isAuthenticated, (value) => {
    if (!value) router.replace({ name: 'TheLogin' })
})
</script>

<template>
    <Toaster position="top-right" :close-button="true" />

    <!-- Signed in: the full frame. Signed out: the auth pages own the window. -->
    <AppShell v-if="isAuthenticated" />
    <RouterView v-else />
</template>
